import Spec from "csi/core/Spec";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import PathMatrix from "csi/table/matrix/Path";
import { pathCreate } from "csi/utility/pathUtility";
import declare from "dojo/_base/declare";

const CalendarActivityMatrix = declare(PathMatrix, {
	bAllowColumnFilter: true,
	bAllowOnRootNode: true,
	columnPath: pathCreate("Master", "Activities"),
	hideLoneSubheader: true,

	/**
	 * @override
	 * Add dependency path to get ProtoActivity nodes
	 */
	addDependencyPaths(h: Heading, paths: string[]): void {
		this.inherited(arguments);
		paths.push(pathCreate(this.columnPath, "Proto"));
	},

	/**
	 * @override
	 * Fill in index based on column node
	 */
	onPathSpecParams(ctx: Context, params: Partial<Spec>, columnIndex?: number): void {
		const masterActivity = ctx.getNode();
		const protoActivity = ctx.cache.get(masterActivity.Proto);

		params.index = masterActivity.Index;

		if (protoActivity.ActivityType === "ACTIVITYTYPE:Milestone") {
			params.css = `${params.css || ""} milestone`;
		}
	},
});

export = CalendarActivityMatrix;
